import { REDUCER_NAME } from "./consts";

export const selectors = {
  selectActiveInboxTab: (state) => state[REDUCER_NAME]?.inboxActiveTab,
  selectLeadArInboxActiveTab: (state) =>
    state[REDUCER_NAME]?.leadArInboxActiveTab,
};
